import { Table, type TableProps } from "antd";
import { useEffect, useState } from "react";
import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import ConfirmModal from "../../components/modal/ConfirmModal";
import ButtonIcon from "../../components/ButtonIcon";
import BaseCard from "../../components/card/BaseCard";
import BaseTable from "../../components/BaseTable";
import ViewDetailContactUsInformation from "../../components/modal/view-detail-contact-us-information";
import { $api, type components } from "../../helper";
import { formatDate } from "../../helper/method";
import { tokenMock } from "../../helper/mock";
import { useNotify } from "../../helper/notify";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import Trash from "../../components/svg/Trash";
import FilterSearch from "../../components/filter/FilterSearch";
import { Icon } from "@iconify/react/dist/iconify.js";

export default function ManagementInformationContactUs() {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDetail, setIsOpenDetail] = useState(false);
  const notify = useNotify();
  const [id, setId] = useState("");
  const { data, refetch, isLoading } = $api.useQuery(
    "get",
    "/site-api/v1/contact-us/",
  );
  const { mutate, isPending } = $api.useMutation(
    "delete",
    "/site-api/v1/contact-us/",
  );
  const detail = $api.useMutation("get", "/site-api/v1/contact-us-detail/");
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("تماس باما");
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteContactUsItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "نام",
      dataIndex: "name",
      key: "name",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.name
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "موضوع",
      key: "subject",
      dataIndex: "subject",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.subject
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "ایمیل",
      key: "email",
      dataIndex: "email",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.email
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "شماره تلفن",
      key: "phone_number",
      dataIndex: "phone_number",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.phone_number
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "توضیحات",
      key: "description",
      dataIndex: "description",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.description
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "تاریخ",
      key: "created",
      dataIndex: "created",
      render: (_, record) => <span>{formatDate(record.created)}</span>,
      sorter: (a, b) =>
        new Date(a.created).getTime() - new Date(b.created).getTime(),
    },
    {
      title: "وضعیت",
      key: "read_by_admin",
      dataIndex: "read_by_admin",
      filters: [
        {
          text: "خوانده شده",
          value: "خوانده شده",
        },
        {
          text: "خوانده نشده",
          value: "خوانده نشده",
        },
      ],
      onFilter: (value, record) =>
        (record.read_by_admin ? "خوانده شده" : "خوانده نشده")
          .toString()
          .indexOf(value as string) === 0,
      render: (value, record) => (
        <span className="">
          {record.read_by_admin ? "خوانده شده" : "خوانده نشده"}
        </span>
      ),
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex">
          <ButtonIcon
            onClick={() => {
              setIsOpenDetail(true);
              detail.mutate({
                params: {
                  query: {
                    contact_us_u_id: record.u_id,
                  },
                },
                headers: {
                  Authorization: tokenMock,
                  lang: "fa",
                },
              });
              setId(record.u_id);
            }}
            icon="solar:eye-linear"
            className="text-primary-500!"
          />
          {/* <ButtonIcon
            icon="solar:trash-bin-trash-linear"
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          /> */}
          <ButtonIconSvg
            icon={<Trash />}
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <ViewDetailContactUsInformation
        data={detail.data?.data}
        isPending={detail.isPending}
        open={isOpenDetail}
        onClose={() => setIsOpenDetail(false)}
      />
      <ConfirmModal
        pending={isPending}
        title="حذف اطلاعات تماس ؟"
        description="حذف این اطلاعات تماس باعث غیر استفاده شدن میشود."
        action={() => {
          mutate(
            {
              params: {
                query: {
                  contact_us_u_id: id,
                },
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                notify.success(data.message);
                setIsOpen(false);
                setId("");
                refetch();
              },
            },
          );
        }}
        open={isOpen}
        onClose={() => {
          setIsOpen(false);
          setId("");
        }}
      />
      <div className="w-full flex justify-between items-center">
        {/* <CustomBreadcrumb first="پشتیبانی" second="مدیریت اطلاعات تماس باما" /> */}
      </div>
      <div>
        <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
          <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
            <Table<components["schemas"]["SiteContactUsItem"]>
              loading={isLoading}
              className="col-span-1!"
              scroll={{ x: "max-content" }}
              columns={columns}
              dataSource={data?.data}
            />
          </BaseTable>
        </BaseCard>
      </div>
    </div>
  );
}
